module.exports = __webpack_public_path__ + "static/media/promo10.9b8fa914.jpg";